import type { TagsProps } from 'components/shared/Tags/model';
import { TagsPicker } from 'components/shared/Tags/tags-picker';
import type { Underlying } from 'models/underlying';
import styled from 'styled-components';

type StylingProps = { isEditing: boolean; locale: string };

function getPlaceholderFontSize({ locale, isEditing }: StylingProps) {
  switch (locale) {
    case 'fr':
      return '12px';
    case 'ja':
      return isEditing ? 'x-small' : 'small';
    default:
      return 'inherit';
  }
}

function UnderlyingTags(props: TagsProps<Underlying>) {
  return <TagsPicker<Underlying> {...props} />;
}

export const CustomizedPlaceholderFontLegacyTags = styled(UnderlyingTags)<StylingProps>`
  .select__placeholder {
    font-size: ${props => getPlaceholderFontSize(props)};
  }
`;
